import type { TFunction } from 'i18next';
import type { AssistantMessageRole } from '@/api/assistant';

/**
 * Who wrote a search hit's line, by its role (TMMAPP-0148 U2 item 12; §D: a scope request is
 * labelled "Scope request"). A hit names no author, so a member's message in a shared session is
 * "Message", and the person's own elsewhere is "You".
 */
export function hitAuthor(t: TFunction, role: AssistantMessageRole, shared: boolean): string {
  if (role === 'SCOPE_REQUEST') return t('assistant.search.roleScope');
  if (role === 'ASSISTANT') return t('assistant.search.roleAssistant');
  return shared ? t('assistant.search.roleMessage') : t('assistant.you');
}
